import { render, staticRenderFns } from "./assign-mistakes.vue?vue&type=template&id=46cc7530&scoped=true"
import script from "./assign-mistakes.vue?vue&type=script&lang=js"
export * from "./assign-mistakes.vue?vue&type=script&lang=js"
import style0 from "./assign-mistakes.vue?vue&type=style&index=0&id=46cc7530&prod&lang=scss&scoped=true"
import style1 from "./assign-mistakes.vue?vue&type=style&index=1&id=46cc7530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc7530",
  null
  
)

export default component.exports